import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-token-error',
    templateUrl: './token-error.component.html',
    styleUrls: ['./token-error.component.css']
})
export class TokenErrorComponent implements OnInit {

    token = '';

    constructor(private router: Router) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.token = navigation.extras.state.token;
        } else {
            this.router.navigateByUrl('/');
        }
    }

    ngOnInit(): void {
        void (0);
    }

    onBackClick() {
        this.router.navigateByUrl('/');
    }
}